<script lang="ts">
	import ErrorPage from '#lib/components/ErrorPage.svelte';
	import { setAttr } from '@directus/visual-editing';
	import { twMerge } from 'tailwind-merge';
	import { HDDivisionType } from '#lib/hockeydata/types/responses/DivisionInfo.js';
	import { page } from '$app/state';

	const { data, params, children } = $props();

	const season = $derived(data.season);

	const hdSeason = $derived(data.hdSeason);

	const hasPlayoffs = $derived.by(() => {
		return !!hdSeason.data.divisions.find(
			(division) => division.divisionType == HDDivisionType.PLAYOFF
		);
	});
</script>

<svelte:head>
	<title>Tigers Paternion | Saison {data.season.title}</title>
</svelte:head>

{#if season}
	<h1
		data-directus={setAttr({
			collection: 'season',
			item: season.id!,
			fields: ['title', 'showTitle'],
			mode: 'popover'
		})}
	>
		Saison {season.title}
	</h1>

	{#snippet menuItem(route: string, label: string, exact: boolean = false)}
		{@const fullRoute =
			(params.wildcats ? '/wildcats' : '') + `/saison/${params.seasonId}/${route}`}
		{@const matches = exact
			? page.url.pathname === fullRoute || page.url.pathname + '/' === fullRoute
			: page.url.pathname.startsWith(fullRoute)}

		<a
			href={fullRoute}
			aria-current={matches ? 'page' : undefined}
			class={twMerge(
				'bg-base-100 shadow-accent/10 grid min-h-11 place-content-center px-4 py-2 text-lg font-bold tracking-wider uppercase hover:shadow-xl',
				matches ? 'border-accent border-b-2' : ''
			)}
		>
			{label}
		</a>
	{/snippet}

	<nav aria-label="Saisonnavigation" class="flex flex-wrap gap-2 [&>a]:grow">
		{@render menuItem('', 'Posts', true)}
		{@render menuItem('spielplan', 'Spielplan')}
		{@render menuItem('tabelle', 'Tabelle')}
		{@render menuItem('teams', 'Teams')}
		{#if hasPlayoffs}
			{@render menuItem('playoffs', 'Playoffs')}
		{/if}
	</nav>

	<div class="min-w-0">
		{@render children()}
	</div>
{:else}
	<ErrorPage
		title="404"
		message="Wir konnten diese Seite leider nicht finden. Überprüfe den Link oder gehe zurück zur Startseite"
		buttonLink="/"
		buttonText="Zurück zur Startseite"
	/>
{/if}
